<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section *ngIf="directSub$ | async as sub" fxFlexFill fxLayout fxLayoutAlign="center center">
  <div class="fs-dialog-contents" fxLayout="column" fxLayoutGap="16px">
    <h1>Deactivate Direct features</h1>

    <ul>
      <li>
        Nothing will happen until the end of your current billing period on
        <strong>{{ sub.next_charge_date | date }}</strong>
        .
      </li>
      <li>You will not be be charged for Direct on your next invoice.</li>
      <li>Your Direct sites and booking widgets will be unpublished at that time.</li>
      <li>Any existing Direct bookings are not impacted.</li>
    </ul>

    <div fxLayout fxLayoutGap="16px">
      <sbnb-button (clicked)="cancel()" [loading]="cancelling">Deactivate Direct features</sbnb-button>
      <sbnb-button type="secondary" (clicked)="dialogRef.close()">Never mind. Don’t deactivate Direct.</sbnb-button>
    </div>
  </div>
</section>
